import {ComponentPropsWithoutRef, FC} from 'react';

interface IBodyProps extends ComponentPropsWithoutRef<'div'> {}

export const Body: FC<IBodyProps> = ({children, ...rest}) => {
    return <div {...rest}>{children}</div>;
};
